import { useSettingsStore } from './useSettingsStore';

/**
 * Custom hook to get the current pathname from the router settings.
 * This hook uses the `useSettingsStore` hook to access the state and retrieve the pathname.
 *
 * @returns {string} - Returns the current pathname from the router settings.
 *
 * @example
 * const pathname = usePathname();
 */
export function usePathname(): string {
  // Destructure the state from the useSettingsStore hook
  const { state } = useSettingsStore();

  // Return the current pathname from the router settings
  return state.settings.router.usePathname();
}
